<template>
  <div id="auth_page" class="row white w-100 h-100 align-items-center">
    <div class="col-12 auth">
      <div class="content">
        <img src="@/assets/images/logo.png" id="logo" />

        <form @submit.prevent="submit">
          
          <InputText
            name="username"
            placeholder="Digite seu e-mail"
            v-model="loginForm.email"
            :error="formErrors.email"
            class="mb-3"
          />
          <PrimaryButtonLoader v-if="loading" class="w-100 d-block mt-4"></PrimaryButtonLoader>
          <PrimaryButton v-else type="submit" class="w-100 d-block mt-4">Recuperar senha</PrimaryButton>
          <router-link :to="{ 'name': 'login'}">
            <WhiteButton class="w-100 d-block mt-4">
              <i class="fa-regular fa-arrow-left-long me-2"></i>
              Voltar</WhiteButton>
          </router-link>
          <p v-if="error">{{ errorMessage }}</p>
        </form>
      </div>
    </div>
  </div>
  </template>
  
  <script setup>
  import { useAuthStore } from '@/stores/AuthStore'
  import { useRouter } from 'vue-router'
  import InputText from '@/components/InputText.vue'
  import PrimaryButton from '@/components/PrimaryButton.vue'
  import PrimaryButtonLoader from '@/components/PrimaryButtonLoader.vue'
  import WhiteButton from '@/components/WhiteButton.vue'
  import { useToast, TYPE } from "vue-toastification"
  import { ref } from 'vue'
  import {errorFormat} from "@/utils/errorFormat";
  
  const loading = ref(false);

  const loginForm = ref({ email: '' })
  const authStore = useAuthStore()
  const router = useRouter()

  const formErrors = ref({});
  const toast = useToast();
  
  const submit = async () => {
    formErrors.value = {};
    loading.value = true;

    const formResult = await authStore.recovery(loginForm.value);
    if(formResult.success){
      toast('Link de redefinição enviado', { type: TYPE.SUCCESS, timeout: 6000 });
      router.push({ name: 'recoveryChangePassword' })
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
    }
    loading.value = false;
  }
  </script>
  
  <style scoped>
  body {
    background-color: #fff;
  }

  .auth {
    max-width: 800px;
    margin: auto;
  }
  </style>

  <style>
  .auth input {
    padding: 14px !important;
  }

  .auth button,
  .register button {
    padding: 14px 40px !important;
  }
  </style>